export const ACQUISITION_TYPE_CODES = {
  rent: 'aluguel',
  purchase: 'compra',
  subscription: 'assinatura',
};
export const SEASONALITY_PERIODS = {
  sevenDays: 7,
  fifteenDays: 15,
  monthly: 30,
  bimestral: 60,
  annual: 365,
  lifetime: 9999,
};
export const MINIMUM_WARRANTY_DAYS = 7;

export const CHECKOUT_OFFER_TYPE_CODE = 'checkout';

export const ACCESS_PROFILE_ID_BY_PLAN_TYPE = {
  duo: 43,
  family: 44,
};
